import React, { useState, useEffect, useMemo } from "react";
import { Tabs, message } from "antd";
//import CashQuotation from "./CashQuotation";
import AccountQuotation from "./AccountQuotation";
import API from "../../../api";
import urls from "../../../api/urls";
import { masterRateCardAPI } from "../../../api/RateCardApi";
import { spaceBeforeCapital } from "../../../utils";

const {
  GET_HUB_PINCODE,
  GET_RATE_CARD_QUOTATION,
  GET_ALL_CHARGES,
  GET_ALL_CALCULATION_BASIS,
} = urls;

const NewRateCard = ({
  getData,
  handleStepsChange = () => {},
  cpPinCodeData,
  goBackStep,
  userType,
  disableEdit = false,
}) => {
  const [activeKey, setActiveKey] = useState("1");
  const [loader, setLoader] = useState(false);
  const [defaultRateCharge, setDefaultRateCharge] = useState([]);
  const [stateCode, setStateCode] = useState(null);
  const [cashData, setCashData] = useState({});
  const [accountData, setAccountData] = useState({});
  const [calculationBasisList, setCalculationBasisList] = useState([]);
  const [defaultRateList, setDefautRateList] = useState([]);

  useEffect(() => {
    fetchInitialData();
    getDefaultRateTemplates();
  }, []);

  const getDefaultRateTemplates = async () => {
    const response = await masterRateCardAPI.getAllRateList();
    setDefautRateList(
      response?.response?.data?.items?.map((item) => ({
        label: item?.name,
        value: item?.rateCardId,
      }))
    );
  };
  useEffect(() => {
    if (getData?.quotations?.length > 0) {
      getData.quotations.forEach((e) => {
        getQuotationDetail(e.rateCardName, e.rateCardType);
      });
    }
    if (getData?.addresses?.find((e) => e?.type?.toUpperCase() === "DEFAULT")) {
      let pincode =
        getData?.addresses?.find((e) => e?.type?.toUpperCase() === "DEFAULT")
          ?.pincode || cpPinCodeData;
      getPicodeState(pincode);
    }
  }, [getData]);

  const getPicodeState = async (pincode) => {
    const response = await API.Api(GET_HUB_PINCODE + pincode).get();
    if (response?.status) {
      setStateCode(response?.response?.data?.stateCode);
    }
  };

  const fetchInitialData = async () => {
    try {
      setLoader(true);
      // let temp = getData?.addresses?.find(
      //   (e) => e?.type?.toUpperCase() === "DEFAULT"
      // );
      //const pincode = temp?.pincode || cpPinCodeData;

      const [chargeRes, calcRes] = await Promise.all([
        API.Api(GET_ALL_CHARGES).get(),

        API.Api(GET_ALL_CALCULATION_BASIS).get(),
      ]);

      if (chargeRes?.status) {
        setDefaultRateCharge(
          chargeRes.response.data.map(({ _id, head, calculationBasis }) => ({
            _id,
            head,
            key: _id,
            calculationBasis,
            global: true,
          }))
        );
      } else {
        message.error(
          chargeRes?.response?.data?.message || "Can't fetch rate charges."
        );
      }

      // if (stateRes?.status) {
      //   setStateCode(stateRes.response?.data?.stateCode);
      // }
      // else {
      //   message.error(
      //     stateRes?.response?.data?.message || "State code fetch failed."
      //   );
      // }

      if (calcRes?.status) {
        setCalculationBasisList(
          calcRes.response?.data?.map((item) => ({
            label: spaceBeforeCapital(item?.name),
            value: item?.name,
            unit: item?.unit,
          }))
        );
      }
    } catch (error) {
      message.error("Failed to fetch initial data.");
    } finally {
      setLoader(false);
    }
  };

  const getQuotationDetail = async (quotation, rateType) => {
    try {
      setLoader(true);
      const res = await API.Api(GET_RATE_CARD_QUOTATION + quotation).get();
      if (res?.status) {
        if (rateType === "CASH") setCashData(res.response?.data);
        if (rateType === "ACCOUNT") setAccountData(res.response?.data);
      }
    } catch (error) {
      message.error("Failed to fetch quotation details.");
    } finally {
      setLoader(false);
    }
  };

  if (userType === "CLIENT") {
    return (
      <AccountQuotation
        handleStepsChange={handleStepsChange}
        getData={getData}
        cpPinCodeData={cpPinCodeData}
        goBackStep={goBackStep}
        loader={loader}
        defaultRateCharge={defaultRateCharge}
        stateCode={stateCode}
        accountData={accountData}
        calculationBasisList={calculationBasisList}
        userType={userType}
        defaultRateList={defaultRateList}
        rateCardType="ACCOUNT"
        disableEdit={disableEdit}
      />
    );
  }

  const tabItems = useMemo(
    () => [
      {
        label: "Cash Rate",
        key: "1",
        children: (
          // <CashQuotation
          //   handleStepsChange={handleStepsChange}
          //   getData={getData}
          //   cpPinCodeData={cpPinCodeData}
          //   goBackStep={goBackStep}
          //   tabChange={() => setActiveKey("2")}
          //   loader={loader}
          //   defaultRateCharge={defaultRateCharge}
          //   stateCode={stateCode}
          //   cashData={cashData}
          //   calculationBasisList={calculationBasisList}
          //   userType={userType}
          //   defaultRateList={defaultRateList}
          // />
          <AccountQuotation
            handleStepsChange={handleStepsChange}
            getData={getData}
            cpPinCodeData={cpPinCodeData}
            goBackStep={goBackStep}
            loader={loader}
            defaultRateCharge={defaultRateCharge}
            stateCode={stateCode}
            accountData={cashData}
            calculationBasisList={calculationBasisList}
            userType={userType}
            defaultRateList={defaultRateList}
            rateCardType="CASH"
            tabChange={() => setActiveKey("2")}
            disableEdit={disableEdit}
          />
        ),
      },
      {
        label: "Account Rate",
        key: "2",
        children: (
          <AccountQuotation
            handleStepsChange={handleStepsChange}
            getData={getData}
            cpPinCodeData={cpPinCodeData}
            goBackStep={goBackStep}
            loader={loader}
            defaultRateCharge={defaultRateCharge}
            stateCode={stateCode}
            accountData={accountData}
            calculationBasisList={calculationBasisList}
            userType={userType}
            defaultRateList={defaultRateList}
            rateCardType="ACCOUNT"
            disableEdit={disableEdit}
          />
        ),
      },
    ],
    [
      handleStepsChange,
      getData,
      cpPinCodeData,
      goBackStep,
      loader,
      defaultRateCharge,
      stateCode,
      cashData,
      accountData,
      calculationBasisList,
      userType,
    ]
  );

  return (
    <Tabs
      activeKey={activeKey}
      type="card"
      onChange={setActiveKey}
      items={tabItems}
      className="rate-card-tab"
    />
  );
};

export default NewRateCard;
